/**
 * Dashboard - Collaboration Story View
 * 
 * DEPRECATED: This component now wraps EQHub for backwards compatibility.
 * New code should import EQHub directly from components/hub/EQHub.
 * 
 * The EQHub provides:
 * - Streak & Momentum (gamification)
 * - Funnel visualization: Found → Scouted → Deployed → Outcomes
 * - What Scout Learned (insights)
 * - Time saved calculation
 * - Activity timeline
 */

import React from "react";
import EQHub from "../hub/EQHub";

/**
 * Dashboard wrapper component
 * Maintains backwards compatibility with existing code that imports Dashboard
 */
export default function Dashboard({ isOpen, onClose, likedCount = 0, archivedCount = 0 }) {
  return <EQHub isOpen={isOpen} onClose={onClose} likedCount={likedCount} archivedCount={archivedCount} />;
}
